import { InteractionRequiredAuthError,PublicClientApplication } from '@azure/msal-browser'

import { RHYBUS_ACCESS_TOKEN } from './Configuration'
import { loginRequest,msalConfig } from './authConfig.ts'



const isTokenExpired = async (): Promise<boolean> => {
  await msalInstance.initialize()
      const accounts:any = msalInstance.getAllAccounts()  
      if (accounts.length === 0) {
        return true // No account found, so consider the token expired
      }
      if (!accounts[0].idToken) {
        return true// No ID token available, consider expired
      }
      const expirationTime = accounts[0].idTokenClaims.exp * 1000     
      return Date.now() > expirationTime// Check if current time is greater than the expiration time
  }

  const logoutIfExpired = async () => {
    await msalInstance.initialize()
      if (await isTokenExpired()) {
        msalInstance.logoutRedirect().then(() => {
            console.log("Logged out due to token expiration.")
          }).catch((error) => {
            console.error("Logout error", error)
          })
        }  
    }

  const logoutUserIfExpired = async () => {
      await msalInstance.initialize()
          msalInstance.logoutRedirect().then(() => {
              console.log("Logged out due to token expiration.")
            }).catch((error) => {
              console.error("Logout error", error)
            })      
  }

  const refreshPageIfExpired = async () => {
      window.location.reload()
    }

const generateSilentTokenIfExpired = async () => {
    await msalInstance.initialize()
    const accounts:any = msalInstance.getAllAccounts()
        if (accounts.length === 0) return
        const request:any = {
        ...loginRequest,
        account: accounts[0],
        }
        try {
        const response:any = await msalInstance.acquireTokenSilent(request)
        localStorage.setItem(RHYBUS_ACCESS_TOKEN,response.accessToken)
        console.log(localStorage.getItem(RHYBUS_ACCESS_TOKEN))
        } catch (error) {
        if (error instanceof InteractionRequiredAuthError) {
            try {
            const response:any = await msalInstance.acquireTokenRedirect(request)
            localStorage.setItem(RHYBUS_ACCESS_TOKEN,response.accessToken)
            } catch (popupError) {
            console.error('Token acquisition failed', popupError)
            }
        } else {
            console.error('Token acquisition failed', error)
        }
        }   
  }

export { generateSilentTokenIfExpired,
    isTokenExpired,
    logoutIfExpired,
    logoutUserIfExpired,
    refreshPageIfExpired }

export const msalInstance = new PublicClientApplication(msalConfig)
